import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Layout, Menu, MenuProps } from 'antd';
import Paths, { Path } from 'routes';
import SubMenu from 'antd/lib/menu/SubMenu';
import { PurpleLogo, UserInfo } from 'components/molecules';
import useStore from 'store';

export interface FooterProps {}

const Footer = (props: FooterProps): React.ReactElement => {
  /* ======================================================
   * stores
   * ====================================================== */
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */

  /* ======================================================
   * hooks
   * ====================================================== */

  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * events
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */

  return (
    <Layout.Footer  className="footer-container">
      <div className="footer">
        <img src="/assets/images/hsg_logo_b.png" alt="logo" />
      </div>
    </Layout.Footer>
  );
};

export default Footer;
